import React from "react";
import { Button } from "@wac-ui-dashboard/wac_component_library";
import useCancelRecheckModal from "./useCancelRecheckModal";

function CancelRecheckModal({
  handleClose,
  refetch,
  selectedId,
  dispatch,
  updateConfig,
}) {
  const { formik } = useCancelRecheckModal({
    refetch,
    handleClose,
    selectedId,
    dispatch,
    updateConfig,
  });
  return (
    <>
      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          What is the reason for cancellation?
        </label>
        <div className="input-wrap">
          <textarea
            id="cancelreason"
            rows={4}
            name="cancelreason"
            className={`pro-input lg ${
              formik.errors.cancelreason &&
              formik.touched.cancelreason &&
              " error"
            }`}
            onChange={(e) =>
              formik?.setFieldValue("cancelreason", e.target.value)
            }
            onBlur={formik?.handleBlur("cancelreason")}
            value={formik?.values?.cancelreason}
          ></textarea>
          {formik.touched.cancelreason && formik.errors.cancelreason && (
            <span className="error-text">{formik.errors.cancelreason}</span>
          )}
        </div>
        <div
          className={`col-12 pro-d-flex pro-justify-end pro-mt-2`}
        >
          <Button className={"pro-btn-link lg pro-px-5"} onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className={"pro-btn-primary lg pro-ms-3"}
            type="submit"
            onClick={formik?.handleSubmit}
          >
            {"Submit"}
          </Button>
        </div>
      </div>
    </>
  );
}

export default CancelRecheckModal;
